<template>
<!-- 加载 -->
<div class="loading">
  <img src="../assets/img/loading.gif">
</div>
</template>

<script>
export default{
	name: 'loading'
}
</script>


// WEBPACK FOOTER //
// src/components/Loading.vue